<template>
  <div>
    <app-header />
    <mpn-page-title :title="pageTitle" />

    <!-- S : state bar -->
    <phase-bar :phase="phase" />
    <!-- E : state bar -->

    <!-- S : main -->
    <router-view

      @phase-change="onPhaseChange"
    />
    <!-- E : main -->

    <app-footer />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';
import AppFooter from '@/components/AppFooter.vue';
import PhaseBar from '../common/PhaseBar.vue';


export default {
  name: 'Composition',
  components: {
    AppHeader,
    AppFooter,
    PhaseBar,
  },
  data() {
    return {
      pageTitle: '마이 팩 by 뉴트리라이트 만들기',
      phase: 1,

    };
  },
  computed: {

  },
  created() {

  },
  methods: {
    onPhaseChange(step) {
      this.phase = step;
    },

  },
};
</script>
